export { default } from "./AnnotationCardAnnotatedText";
